import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ dynamic: true, namespaced: true, store, name: "modal-ttd" })
class ModalTandaTangan extends VuexModule {
  show = false
  saving = false
  document: string | null = null;
  document_id: number | null = null;


  @Mutation
  SET_SHOW(value: boolean) {
    this.show = value;
  }

  @Mutation
  SET_SAVING(value: boolean) {
    this.saving = value;
  }

  @Mutation
  SET_DOCUMENT(params: { document: string, document_id: number }) {
    this.document = params.document;
    this.document_id = params.document_id;
  }

  @Mutation
  CLEAR_DOCUMENT() {
    this.document = null;
    this.document_id = null;
  }

  @Action({ rawError: true })
  showModal(params: { document: string, document_id: number }) {
    this.SET_DOCUMENT(params);
    this.SET_SHOW(true);
  }

  @Action({ rawError: true })
  closeModal() {
    this.CLEAR_DOCUMENT();
    this.SET_SHOW(false);
  }
}

export default getModule(ModalTandaTangan);
